module.exports = __webpack_public_path__ + "static/media/rx_logo.b6ec93fa.PNG";